import React, { ReactNode, useState, useContext, createContext } from 'react';

interface TripInvitationContextType {
  refreshInvitations: boolean;
  setRefreshInvitations: (refreshTrip: boolean) => void;
}

const TripInvitationContext = createContext<
  TripInvitationContextType | undefined
>(undefined);

const TripInvitationProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [refreshInvitations, setRefreshInvitations] = useState<boolean>(false);

  return (
    <TripInvitationContext.Provider
      value={{
        refreshInvitations,
        setRefreshInvitations
      }}
    >
      {children}
    </TripInvitationContext.Provider>
  );
};

const useTripInvitation = () => {
  const context = useContext(TripInvitationContext);
  if (context === undefined || context.refreshInvitations === undefined) {
    throw new Error(
      'useTripInvitation must be used within a TripInvitationProvider'
    );
  }
  return context;
};

export { TripInvitationProvider, useTripInvitation };
